import { createContext, useState } from "react";

const SessionContext = createContext();

/*
    This file manages certain actions, like favoriting a project, picking tags and sorting projects. 
    if tag popup is open (so it can be opened by "See all categories")
*/

export function SessionProvider({ children }) {
  const [chosenTags, setChosenTags] = useState([]);
  const [chosenSeries, setChosenSeries] = useState([]);

  return (
    <SessionContext.Provider
      value={{
        chosenTags: chosenTags,
        setChosenTags: setChosenTags,
        chosenSeries,
        setChosenSeries: setChosenSeries,
        aVariable: 1,
      }}
    >
      {children}
    </SessionContext.Provider>
  );
}

export default SessionContext;
